import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { css } from 'styled-components';
import { colorGreen20, colorRed30, colorYellow20 } from '../../../../tokens';
import { token } from '../../../../system/mixins';
import { getMessageLevel } from '../../../../components/Message/utils/getMessageLevel';
var levelToColor = {
  success: colorGreen20,
  info: null,
  warning: colorYellow20,
  error: colorRed30
};
export var getMessageOverride = function getMessageOverride(props) {
  var level = getMessageLevel(props);
  var color = levelToColor[level];
  var result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        background-color: ", ";\n    "])), token('body.backgroundColor'));

  if (color) {
    result = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            ", ";\n            border-color: ", ";\n\n            .Message-Icon {\n                color: ", ";\n            }\n        "])), result, color, color);
  }

  return result;
};